<template>
  <v-content>
    <AppBar title="Fullt tåg" />

    <v-container class="pb-8">
      <v-row no-gutters>
        <v-col>
          <v-dialog
            ref="dialog"
            v-model="dateModal"
            :return-value.sync="filter.date"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                filled
                v-model="filter.date"
                label="Datum"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="sv"
              first-day-of-week="1"
              v-model="filter.date"
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dateModal = false"
                >Avbryt</v-btn
              >
              <v-btn
                text
                color="primary"
                @click="$refs.dialog.save(filter.date)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>

          <v-row>
            <v-col>
              <v-text-field
                filled
                :loading="$apollo.loading"
                label="Tågnummer"
                @input="onInputFilterTrainNumber"
                type="number"
                v-model.number="filter.train_number"
              />
            </v-col>
            <v-col>
              <v-text-field
                filled
                disabled
                label="Annonserat tågnr"
                type="number"
                :value="advertisedTrainnumber"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="isDefinition" no-gutters>
        <v-col>
          <p>Stämmer följande påstående?</p>
          <v-checkbox
            v-model="model.definition_text"
            :false-value="null"
            :true-value="definition.definition_text"
            :label="definition.definition_text"
          />
          <v-select
            v-model="model.station"
            :items="definition.stations"
            filled
            label="Efter vilken station blev det fullt?"
          />

          <p>Föregående tåg var inställt (måste anges):</p>
          <v-radio-group v-model="model.canceled">
            <v-radio label="Ja" :value="true"></v-radio>
            <v-radio label="Nej" :value="false"></v-radio>
          </v-radio-group>

          <p>Indragen vagn i detta tåg (måste anges):</p>
          <v-radio-group v-model="model.reduced">
            <v-radio label="Ja" :value="true"></v-radio>
            <v-radio label="Nej" :value="false"></v-radio>
          </v-radio-group>

          <p>Tjänstgör i (måste anges):</p>
          <v-radio-group v-model="model.position">
            <v-radio
              v-for="position in positions"
              :key="position"
              :label="position"
              :value="position"
            ></v-radio>
          </v-radio-group>
          <v-textarea filled label="Övrigt" v-model="model.comment" />
        </v-col>
      </v-row>
      <v-row v-else-if="isNoDataTrainnumber">
        <v-col>
          <v-card tile>
            <v-card-text>
              Tågnumret är i korrekt format men information om passerplatser
              saknas, vilket gör att du inte kan fortsätta. Om tågnumret är
              korrekt för denna gångdagen vänligen skicka ett felmeddelande till
              <a
                href="mailto:felanmalan@sjgot.se?subject=Fullt tåg problem. Tågnummer saknas"
                >felanmalan@sjgot.se</a
              >
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col>
          <v-card tile>
            <v-card-text class="d-flex align-center">
              <v-icon class="mr-4">mdi-information-outline</v-icon>
              Sök på tågnummer för att visa formuläret...
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="showValidationModal" max-width="290">
      <ValidationModal
        :errors="validationErrors"
        @close="showValidationModal = false"
        v-if="showValidationModal"
      />
    </v-dialog>
    <v-footer fixed color="white" elevation="2" class="pa-2">
      <v-spacer></v-spacer>
      <v-btn
        :disabled="
          !filter.train_number || filter.train_number.toString().length < 4
        "
        :loading="pendingRegister"
        tile
        color="primary"
        @click="onRegister"
        >Registrera</v-btn
      >
    </v-footer>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar.vue'

import ValidationModal from '@/components/ValidationModal'
import { format } from 'date-fns'
import gql from 'graphql-tag'

export default {
  name: 'CrowdedTrain',

  components: {
    AppBar,
    ValidationModal
  },

  data: () => ({
    advertisedTrainnumber: null,
    showValidationModal: false,
    pendingRegister: false,
    dateModal: false,
    positions: ['M1', 'M2', 'M3'],
    model: {
      position: null,
      canceled: null,
      reduced: null,
      definition_text: null,
      comment: null,
      station: null
    },
    filter: {
      train_number: null,
      date: format(new Date(), 'yyyy-MM-dd')
    }
  }),

  apollo: {
    definition: {
      query: gql`
        query definition($filter: DefinitionFilter!) {
          definition(filter: $filter) {
            definition_text
            stations
            advertised_train_ident
          }
        }
      `,
      skip: true,
      debounce: 300,
      result({ data: { definition } }) {
        if (definition && definition.advertised_train_ident) {
          this.advertisedTrainnumber = definition.advertised_train_ident
        } else {
          this.advertisedTrainnumber = null
        }
      },
      variables() {
        return {
          filter: {
            ...this.filter
          }
        }
      }
    }
  },

  methods: {
    onInputFilterTrainNumber() {
      this.$apollo.queries.definition.skip = false
    },

    async onRegister() {
      if (this.validationErrors.length) {
        return (this.showValidationModal = true)
      }

      this.pendingRegister = true

      const { data } = await this.$apollo.mutate({
        mutation: gql`
          mutation registerCrowdedTrain($payload: RegisterCrowdedTrainInput!) {
            registerCrowdedTrain(payload: $payload) {
              train_number
              user
              date
              station
              definition_text
              created
            }
          }
        `,

        variables: {
          payload: {
            train_number:
              this.advertisedTrainnumber || this.filter.train_number,
            date: this.filter.date,
            ...this.model
          }
        }
      })

      this.$store.set('registration/data', data.registerCrowdedTrain)
      this.$router.push('/crowded-train-registration-completed')
      this.pendingRegister = false
    }
  },

  computed: {
    validationErrors() {
      const errors = []

      if (!this.model.definition_text) {
        errors.push('Påstående ej markerad')
      }

      if (!this.model.station) {
        errors.push('Station ej vald')
      }

      if (!this.model.position) {
        errors.push('Position ej vald')
      }

      if (this.model.canceled === null) {
        errors.push('Föregående tåg var inställt ej vald')
      }

      if (this.model.reduced === null) {
        errors.push('Indragen vagn ej vald')
      }

      return errors
    },

    isDefinition() {
      return (
        this.definition &&
        this.definition.definition_text &&
        this.definition.stations.length
      )
    },

    isNoDataTrainnumber() {
      return (
        !this.$apollo.loading &&
        !this.isDefinition &&
        (this.filter.train_number || '').toString().length > 3
      )
    }
  }
}
</script>
